<template>
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-12">
                <div class="header mt-md-5">
                    <div class="header-body">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="header-pretitle">{{$t('manage')}}</h6>
                                <h1 class="header-title">{{$t('Objectively DB')}}</h1>
                            </div>
                            <div class="col-auto">
                                <button
                                    @click="openModal({id:'OdbEditModal', model:{parentId, language}})"
                                    class="btn btn-primary"
                                >{{$t('Add')}}</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <div class="card" data-toggle="lists">
                            <div class="card-header">
                                <div class="row align-items-center">
                                    <div class="col">
                                        <!-- Search -->
                                        <div class="row align-items-center">
                                            <div class="col-auto pr-0">
                                                <span class="fe fe-x text-muted" v-if="query" @click="query=null"></span>
                                                <span class="fe fe-search text-muted" v-else></span>
                                            </div>
                                            <div class="col">
                                                <input
                                                    type="search"
                                                    v-model="query"
                                                    class="form-control form-control-flush search no-glow"
                                                    :placeholder="$t('Search')"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-auto"></div>
                                    <div class="col-auto">
                                        <div class="dropdown"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body p-0 pl-4 pr-4" v-if="breadcrumbs.length>0">
                                <b-breadcrumb :items="breadcrumbs"></b-breadcrumb>
                            </div>
                            <simple-table
                                :data="odb"
                                :loading="cdbLoading"
                                :edit="edit"
                                :deleteItem="deleteItem"
                                :columns="columns"
                                :sort="sort"
                            ></simple-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <odb-modal id="OdbEditModal" :data="model"></odb-modal>
    </div>
</template>

<script>
import SimpleTable from '@/components/SimpleTable.vue'
import OdbModal from './OdbModal.vue';
import { modalMixins } from '@/mixins/modal.js'
import { odbMixins } from '@/mixins/odb.js'
import { mapActions, mapGetters, mapState } from 'vuex';


export default {
    props: ['parentId'],
    mixins: [modalMixins, odbMixins],
    components: {
        SimpleTable,
        OdbModal
    },
    data() {
        return {
            query: null,
            language: 'english',
            model: {},
            columns: [
                {
                    label: 'Code',
                    name: 'code',
                },
                {
                    label: 'Name',
                    name: 'label',
                    // link: (item) => {
                    //     return {
                    //         name: 'company.odb',
                    //         params: { parentId: item._id }
                    //     }
                    // },
                    field: (item) => {
                        if (item.label.length > 50) {
                            return item.label.substring(0, 50) + '...';
                        } else {
                            return item.label
                        }
                    },
                    subtitle: (item) => {
                        if (!item.description) return;
                        if (item.description.length > 50) {
                            return item.description.substring(0, 50) + '...';
                        } else {
                            return item.description;
                        }
                    },
                },


            ],
            sort: '',
            breadcrumbs: [],
        }
    },

    created() {
        this.queryItems();

    },

    methods: {
        ...mapActions('odb', ['find', 'create', 'patch', 'remove', 'get']),

        getParents(parentId) {
            if (!parentId) return;
            this.get(parentId).then(item => {
                this.breadcrumbs.unshift({
                    text: item.label,
                    to: {
                        name: 'company.odb',
                        params: {
                            parentId: item._id
                        }
                    },
                });

                if (item.parentId) {
                    this.getParents(item.parentId);
                } else {
                    this.breadcrumbs.unshift({
                        text: 'Home',
                        to: {
                            name: 'company.odb',
                        }

                    });
                }
            });
        },


        edit(item) {
            this.openModal({ id: 'OdbEditModal', model: item });
        },
        deleteItem(item) {
            this.remove(item._id).then(data => {
                this.$toasted.global.success({
                    message: this.$t('Item has been deleted')
                });
            })
        },



    }
}
</script>
